export { STYLED_PROPS } from './styledProps'
